var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000026132490717748204870000007211233369761075089_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video_camera"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.7 240.1h320c20.3 0 36.7 16.4 36.7 36.7v148.2c0 20.3-16.4 36.7-36.7 36.7h-320c-20.3 0-36.7-16.5-36.7-36.8v-148.1c0-20.3 16.4-36.7 36.7-36.7z",
    fill: "#2c5ede"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#95baf9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m460.2 438.5-66.8-29.9v-115.4l66.8-29.9c18.5-8.3 40.2 0 48.5 18.5 2.1 4.7 3.2 9.8 3.2 15v108.2c0 20.3-16.4 36.7-36.7 36.7-5.1 0-10.2-1.1-15-3.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.7,
    cy: 140.2,
    r: 89.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.8,
    cy: 159.7,
    r: 70.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.9aee301862378a407848c586d23a86f5.svg";
export { ForwardRef as ReactComponent };